import { add, endOfQuarter, endOfYear, startOfQuarter, startOfYear, sub } from "date-fns";
import config from "@/config";
import { preparedDate } from "../config";
import { lastWeekKey } from "./config";

export const dateToUTC = (date: Date): Date => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0));
};

export const getPrevDateFrom = (date: string | Date, duration: Duration): Date => {
  const d = date instanceof Date ? date : new Date(date);
  return dateToUTC(sub(d, duration));
};

export const getNextDateFrom = (date: string | Date, duration: Duration): Date => {
  const d = date instanceof Date ? date : new Date(date);
  return dateToUTC(add(d, duration));
};

export const getQuarterFrom = (date: Date): { dateFrom: Date; dateTo: Date } => {
  const quarterStart = startOfQuarter(date);
  const quarterEnd = endOfQuarter(date);
  return {
    dateFrom: dateToUTC(quarterStart),
    dateTo: getNextDateFrom(quarterEnd, { days: 1 }),
  };
};

export const getYearFrom = (date: Date): { dateFrom: Date; dateTo: Date } => {
  const yearStart = startOfYear(date);
  const yearEnd = endOfYear(date);
  return {
    dateFrom: dateToUTC(yearStart),
    dateTo: getNextDateFrom(yearEnd, { months: 1 }),
  };
};

export const serializeDate = (date: string, options?: Intl.DateTimeFormatOptions): string =>
  new Date(date).toLocaleString(config.locale, options);
